import { GridCurve } from '@/dto/scenario/grid/GridCurve';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class GridCurveExt extends DtoExt {

  public static fromDto(dto: GridCurve): GridCurveExt {
    return new GridCurveExt({
      valuesIsCheap: dto.valuesIsCheap,
      valuesTariff: dto.valuesTariff,
      valuesIsAvailable: dto.valuesIsAvailable,
      valuesPrice: dto.valuesPrice,
      durationYear: dto.durationYear,
      startDate: dto.startDate && new Date(dto.startDate),
      stepMinutes: dto.stepMinutes
    } as any);
  }

  public valuesIsCheap: number[] | null = null;
  public valuesTariff: string[] | null = null;
  public valuesIsAvailable: number[] | null = null;
  public valuesPrice: number[] | null = null;

  public durationYear: number | null = null;

  public startDate: Date | null = null;

  public stepMinutes: number | null = null;

  constructor(options?: GridCurveExt | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
      // this.valuesIsCheap = options.valuesIsCheap;
      // this.valuesTariff = options.valuesTariff;
      // this.valuesIsAvailable = options.valuesIsAvailable;
      // this.valuesPrice = options.valuesPrice;
      // this.durationYear = options.durationYear;
      // this.startDate = options.startDate;
      // this.stepMinutes = options.stepMinutes;
    }
  }

  public toDto(): GridCurve {
    return new GridCurve({
      valuesIsCheap: this.valuesIsCheap,
      valuesTariff: this.valuesTariff,
      valuesIsAvailable: this.valuesIsAvailable,
      valuesPrice: this.valuesPrice,
      durationYear: this.durationYear,
      startDate: this.startDate,
      stepMinutes: this.stepMinutes
    });
  }
}
